var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout-full',{attrs:{"breadcrumb":_vm.breadcrumb},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Сменить регион")]},proxy:true},{key:"nav",fn:function(){return [_c('nav-tab')]},proxy:true}])},[(_vm.isLoading)?_c('base-loading'):_c('area-form',{attrs:{"value":_vm.area},on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }